/* Accounts are optional — everything works signed out (local-first). Signing in
   adds cloud sync between devices. 2FA (TOTP authenticator apps + backup codes)
   and passkeys (Face ID / Touch ID) come from better-auth plugins, so the
   security-sensitive code is the library's, not ours. */
import { createAuthClient } from 'better-auth/react';
import { twoFactorClient } from 'better-auth/client/plugins';
import { passkeyClient } from '@better-auth/passkey/client';

/* "Password accepted, now enter your 2FA code" has to survive two things:
   - better-auth refetching the session after sign-in, which (while signed out)
     flips useSession back to isPending and remounts the sign-in screen;
   - switching to the authenticator app on iPhone, which can reload the PWA.
   So it lives in storage for as long as the server's 2FA cookie (10 min). */
const LS_2FA = 'ftu_2fa_pending';
const TWO_FA_MS = 10 * 60_000;
export const twoFactorPending = () => { try { return Date.now() - Number(localStorage.getItem(LS_2FA) || 0) < TWO_FA_MS; } catch { return false; } };
export const setTwoFactorPending = (on: boolean) => {
  try { if (on) localStorage.setItem(LS_2FA, String(Date.now())); else localStorage.removeItem(LS_2FA); } catch {}
  window.dispatchEvent(new Event('ftu:2fa-changed'));
};

export const authClient = createAuthClient({
  baseURL: typeof location !== 'undefined' ? `${location.origin}/api/auth` : undefined,
  plugins: [
    twoFactorClient({
      // Password was right but 2FA is on — the Account page shows the code step.
      onTwoFactorRedirect: () => setTwoFactorPending(true),
    }),
    passkeyClient(),
  ],
});

export const { useSession, signIn, signUp, signOut } = authClient;
